import { useState } from 'react';
import './FileTree.css';

function FileTree({ files, onFileSelect, selectedFile }) {
    const [expandedFolders, setExpandedFolders] = useState(new Set(['workspace']));

    const toggleFolder = (path) => {
        const newExpanded = new Set(expandedFolders);
        if (newExpanded.has(path)) {
            newExpanded.delete(path);
        } else {
            newExpanded.add(path);
        }
        setExpandedFolders(newExpanded);
    };

    const getFileIcon = (name) => {
        const ext = name.split('.').pop().toLowerCase();
        const iconMap = {
            js: '/svg/javascript-plain.svg',
            jsx: '/svg/javascript-plain.svg',
            py: '/svg/python.svg',
            json: '/svg/file-code.svg',
            md: '/svg/markdown.svg',
            css: '/svg/file-type-svg.svg',
            html: '/svg/html5.svg',
            ts: '/svg/typescript-plain.svg',
            tsx: '/svg/brand-typescript.svg',
            svg: '/svg/file-type-svg.svg',
            pdf: '/svg/file-pdf.svg',
        };
        return iconMap[ext] || '/svg/file-line.svg';
    };

    // Render tree from backend API format { name, path, is_dir, children }
    const renderNode = (node, level = 0) => {
        if (!node) return null;

        const isExpanded = expandedFolders.has(node.path || node.name);
        const isSelected = selectedFile === node.path;

        if (node.is_dir) {
            return (
                <div key={node.path || node.name} className="tree-folder">
                    <div
                        className={`tree-item folder ${isExpanded ? 'expanded' : ''}`}
                        style={{ paddingLeft: `${level * 16 + 8}px` }}
                        onClick={() => toggleFolder(node.path || node.name)}
                    >
                        <img
                            src={isExpanded ? '/svg/white-folder.svg' : '/svg/folder.svg'}
                            alt="folder"
                            className="folder-icon"
                        />
                        <span className="tree-label">{node.name}</span>
                    </div>
                    {isExpanded && node.children && (
                        <div className="tree-children">
                            {node.children.map(child => renderNode(child, level + 1))}
                        </div>
                    )}
                </div>
            );
        } else {
            return (
                <div
                    key={node.path}
                    className={`tree-item file ${isSelected ? 'selected' : ''}`}
                    style={{ paddingLeft: `${level * 16 + 24}px` }}
                    onClick={() => onFileSelect(node.path)}
                >
                    <img src={getFileIcon(node.name)} alt="file" className="file-icon" />
                    <span className="tree-label">{node.name}</span>
                </div>
            );
        }
    };

    if (!files) {
        return (
            <div className="file-tree">
                <div className="file-tree-header">
                    <span>FILES</span>
                </div>
                <div className="file-tree-content">
                    <div style={{ padding: '16px', color: '#5f6368' }}>
                        Loading files...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="file-tree">
            <div className="file-tree-header">
                <span>FILES</span>
            </div>
            <div className="file-tree-content">
                {renderNode(files)}
            </div>
        </div>
    );
}

export default FileTree;
